import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStoreService } from '../services/auth-store.service';

export const profileGuard: CanActivateFn = async (_route, _state) => {
  const authStore = inject(AuthStoreService);
  const router = inject(Router);

  await authStore.initialize();

  const roles = authStore.user()?.type ?? [];

  // Si el usuario es admin o superadmin, redirigir al panel de admin
  if (roles.includes('ADMIN') || roles.includes('SUPERADMIN') || roles.includes('MANAGER')) {
    return router.createUrlTree(['/admin']);
  }

  return true;
};
